import { useCallback, useRef, useState } from "react";

export function useAlmostInView(threshold = 0, rootMargin = `100px`): [(node: Element | null) => void, boolean] {
  const [isAlmostInView, setIsAlmostInView,] = useState(false);
  const observerRef = useRef<IntersectionObserver | null>(null);

  const ref = useCallback((node: Element | null) => {
    if (observerRef.current) {
      observerRef.current.disconnect();
      observerRef.current = null;
    }
    if (!node) return;
    const observer = new IntersectionObserver(
      ([entry,]) => setIsAlmostInView(entry.isIntersecting),
      { rootMargin, threshold, }
    );
    observer.observe(node);
    observerRef.current = observer;
  }, [threshold, rootMargin,]);

  return [ref, isAlmostInView,];
}
